import type React from 'react';

export default function KoobLabeledIcon({
  icon,
  label,
  children,
}: {
  icon: string;
  label?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex space-x-1.5 items-center">
      <i className={[icon, 'text-gray-700'].join(' ')} />
      <div className="text-gray-500">{children ?? label}</div>
    </div>
  );
}
